import {
  CheckOutlined,
  CloseOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { styled } from '@aibi-ui/core';
import { Dropdown as AntdDropdown, Checkbox } from 'antd';
import { DropDownProps } from 'antd/lib/dropdown';
import { useEffect, useState } from 'react';
import { Input } from 'antd';
import TruncatedText from '../../../components/TruncatedText';
import IconChatActions from '@gainer-ui/ai-bi-chat/assets/icons/chat-actions.svg';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid transparent;
  color: #333;
  gap: 8px;
  &.active,
  &:hover {
    background: #fff;
    border-color: #d2d2d2;
    transition: all 0.1 ease;
    .chat-actions {
      display: flex;
    }
  }
  .chat-actions {
    display: none;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    color: #999;
    border-radius: 4px;
    transition: all 0.1s ease;
    svg {
      font-size: 14px;
      transition: all 0.1s ease;
    }
    &:hover {
      background: #f3f4f6;
      svg {
        color: #666;
      }
    }
  }
  .ant-dropdown-menu-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
  }
  .ant-input {
    padding-left: 0;
    height: 38px;
    border: none;
    box-shadow: none;
  }
  .edit-input {
    display: flex;
    flex: 1;
    .ant-input-affix-wrapper {
      padding: 0;
      border: none;
      height: 38px;
    }
    .edit-check {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      > div {
        font-size: 10px;
        width: 26px;
        min-width: 26px;
        height: 26px;
        min-height: 26px;
        text-align: center;
        line-height: 26px;
        border-radius: 6px;
        &:hover {
          background: rgb(238, 243, 255);
          color: #5687ff;
        }
      }
    }
  }
`;

const HistoryItemName = styled.div`
  flex: 1;
  height: 38px;
  line-height: 38px;
  color: #333;
  cursor: pointer;
  overflow: hidden;
  font-size: 14px;
`;

const ConversationItem = ({
  active,
  name,
  checked,
  onClick,
  showCheckbox,
  editNameFun,
  toggleCheckbox,
  showMoreAction = true,
  moreAction,
}: {
  active: boolean;
  name: string;
  checked: boolean;
  onClick: () => void;
  showCheckbox: boolean;
  editNameFun: (name: string) => Promise<boolean>;
  toggleCheckbox: (checked: boolean) => void;
  showMoreAction?: boolean;
  moreAction?: (props: {
    setIsEditing: (isEditing: boolean) => void;
  }) => DropDownProps['overlay'];
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(name);
  useEffect(() => {
    setEditedName(name);
  }, [name]);

  const [isNameSaving, setIsNameSaving] = useState(false);
  /** 保存名称 */
  const handleSaveName = async () => {
    if (isNameSaving) {
      return;
    }
    setIsNameSaving(true);
    try {
      if (editedName !== name) {
        const flag = await editNameFun(editedName);
        if (flag) {
          setIsEditing(false);
        }
      } else {
        setIsEditing(false);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsNameSaving(false);
    }
  };

  return (
    <Container
      className={active ? 'active' : ''}
      style={isEditing ? { background: '#fff', borderColor: '#5687ff' } : {}}
    >
      {showCheckbox && (
        <Checkbox
          style={{ marginRight: '4px' }}
          checked={checked}
          onChange={e => toggleCheckbox(e.target.checked || false)}
        />
      )}
      {isEditing ? (
        <div className="edit-input">
          <Input
            autoFocus
            value={editedName}
            onInput={e => setEditedName(e.currentTarget.value)}
            onPressEnter={() => handleSaveName()}
            suffix={<></>}
          />
          <div className="edit-check">
            {isNameSaving ? (
              <LoadingOutlined />
            ) : (
              <div
                className="flex justify-center items-center text-[#5687ff]"
                onClick={() => handleSaveName()}
              >
                <CheckOutlined />
              </div>
            )}
            <div
              className="flex justify-center items-center"
              onClick={e => {
                setEditedName(name);
                setIsEditing(false);
              }}
            >
              <CloseOutlined />
            </div>
          </div>
        </div>
      ) : (
        <HistoryItemName onClick={() => onClick()}>
          <TruncatedText
            text={name}
            lineClamp={1}
            tooltipProps={{
              mouseEnterDelay: 0.5,
              openClassName: 'w-full',
              placement: 'topLeft',
              align: { offset: [-12, 0] },
            }}
          />
        </HistoryItemName>
      )}
      {!isEditing && !showCheckbox && showMoreAction && moreAction && (
        <AntdDropdown
          overlayClassName="custom-conversation-actions"
          overlay={moreAction({ setIsEditing })}
        >
          <div className="chat-actions">
            <IconChatActions viewBox="0 0 16 16" />
          </div>
        </AntdDropdown>
      )}
    </Container>
  );
};

export default ConversationItem;
